import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.presentation');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-presentation',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.presentation/view.scss */
/* Undefined variable.
   ╷
77 │   .footer-title { font-size: 11px; color: $gray-400; }
   │                                           ^^^^^^^^^
   ╵
  src/app/page.presentation/view.scss 77:43  root stylesheet */`],
})
export class PagePresentationComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public currentSlide: number = 0;
    public totalSlides: number = 23;
    public showOverview: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        document.addEventListener('keydown', this.handleKey.bind(this));
        await this.service.render();
    }

    public handleKey(e: KeyboardEvent) {
        if (e.key === 'ArrowRight' || e.key === ' ' || e.key === 'PageDown') {
            e.preventDefault();
            this.next();
        } else if (e.key === 'ArrowLeft' || e.key === 'PageUp') {
            e.preventDefault();
            this.prev();
        } else if (e.key === 'Home') {
            e.preventDefault();
            this.goTo(0);
        } else if (e.key === 'End') {
            e.preventDefault();
            this.goTo(this.totalSlides - 1);
        } else if (e.key === 'Escape') {
            e.preventDefault();
            this.showOverview = false;
            this.service.render();
        } else if (e.key === 'o' || e.key === 'O') {
            e.preventDefault();
            this.showOverview = !this.showOverview;
            this.service.render();
        }
    }

    public async next() {
        if (this.currentSlide < this.totalSlides - 1) {
            this.currentSlide++;
            await this.service.render();
        }
    }

    public async prev() {
        if (this.currentSlide > 0) {
            this.currentSlide--;
            await this.service.render();
        }
    }

    public async goTo(index: number) {
        this.currentSlide = index;
        this.showOverview = false;
        await this.service.render();
    }

    public get progress() {
        return ((this.currentSlide + 1) / this.totalSlides) * 100;
    }

    public slideLabels: string[] = [
        '표지',
        '목차',
        '사업 개요 & 추진 배경',
        '데이터 현황 및 사업 범위',
        '전체 시스템 아키텍처',
        '데이터 수집 파이프라인',
        'OCR · NER · 전처리 파이프라인',
        '검색엔진 구축 및 최적화',
        '지식그래프 온톨로지 설계',
        '지식그래프 구축 파이프라인',
        'AI 에이전트 전체 아키텍처',
        'Graph-RAG 멀티스텝 파이프라인',
        '5대 AI 에이전트 상세',
        '데이터 저작도구 플랫폼',
        '에이전트 응용 도구',
        '2패널 UI/UX 설계',
        '보안 체계',
        '품질 · 테스트 전략',
        '추진 일정 (6개월)',
        '추진 체계 · 인력 · 핵심 KPI',
        '기대 효과 및 5개년 로드맵',
        '당사 역량 및 수행 경험',
        '감사합니다'
    ];
}

export default PagePresentationComponent;